import { render, staticRenderFns } from "./LastNewsComponent.vue?vue&type=template&id=46a21c84&scoped=true"
import script from "./LastNewsComponent.vue?vue&type=script&lang=js"
export * from "./LastNewsComponent.vue?vue&type=script&lang=js"
import style0 from "./LastNewsComponent.vue?vue&type=style&index=0&id=46a21c84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a21c84",
  null
  
)

export default component.exports